import React from "react";
import { AxisOptions, Chart } from "react-charts";

import styled from "styled-components";
import { DataPoint } from "./placeholderdata";

interface IProps {
  data: {
    label: string;
    data: {
      date: Date;
      value: number;
    }[];
  }[];
}

const Graph = ({ data }: IProps) => {
  const primaryAxis = React.useMemo<AxisOptions<DataPoint>>(
    () => ({
      getValue: (datum) => datum.date,
      scaleType: "time"
    }),
    []
  );

  const secondaryAxes = React.useMemo<AxisOptions<DataPoint>[]>(
    () => [
      {
        getValue: (datum) => datum.value,
        elementType: "area",
        valueFormatter: (val: number) => `${(val / 1000).toFixed(1)}k`
      }
    ],
    []
  );
  return (
    <Container>
      <Chart
        options={{
          data: data ?? [],
          primaryAxis,
          secondaryAxes,
          dark: true,
          getSeriesStyle: (series) => {
            const baseColorMap: Record<string, string> = {
              Spotify: "#25CF5E",
              "Apple Music": "#F1465C",
              Deezer: "#A238FF",
              Amazon: "#2B94D0",
              Youtube: "#FF0000"
            };

            const color =
              baseColorMap[series.label as keyof typeof baseColorMap] ?? "#ccc";

            return {
              color,
              area: {
                fill: `${color}1b` // adds transparency to area (e.g. '#25cf5e1b')
              }
            };
          }
        }}
      />
    </Container>
  );
};

export default Graph;

const Container = styled.div`
  width: 100%;
  height: 100%;
  font-family: "Switzer", sans-serif;
`;
